import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CloseRoundDuotone(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 12, cy: 12, r: 9, fill: "#7e869e", fillOpacity: 0.25 }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.2, d: "m16 8-8 8M8 8l8 8" })));
}
const CloseRoundDuotone = forwardRef(_CloseRoundDuotone);
export { CloseRoundDuotone };
